<template>
  <div v-if="showModal" class="modal false z-50 fixed w-full h-full top-0 left-0 flex items-center justify-center">
    <div class="absolute w-full h-full bg-gray-900 opacity-50 modal-overlay" @click="showModal = false"></div>
    <div class="z-50 w-11/12 mx-auto overflow-y-auto bg-white rounded shadow-lg modal-container md:max-w-5xl">
      <div class="px-6 py-4 text-left modal-content flex flex-col">
        <div class="flex items-center justify-between pb-3">
          <p class="text-2xl font-bold">{{ file.filename }}</p>
          <div class="z-50 cursor-pointer modal-close" @click="showModal = false">
            <XIcon class="w-5 h-5 text-black"/>
          </div>
        </div>
        <div class="mb-4 flex-auto">
          <div class="mb-8 h-full">
            <embed class="w-full h-full" :src="`data:application/pdf;toolbar=0&;base64,${file.base64}`">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import fileApi from "../../../../api/file";

export default {
  data() {
    return {
      showModal: false,
      file: null,
    }
  },
  beforeMount() {
    this.$emitter.on('open-applicant-application-pdf-file', file => {
      this.$emitter.emit('open-loader-modal')
      fileApi.getApplicantApplicationFile(file.id, this.$route.params.applicationId).then(res => {
        this.file = res.data
        this.showModal = true
      }).catch(error => {
        this.$snotify.error(error)
      }).finally(() => {
        this.$emitter.emit('close-loader-modal')
      })
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-applicant-application-pdf-file')
  }
}
</script>
<style scoped>
.modal-content {
  height: 90vh;
}
</style>